import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import { Component, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";

import { DragulaService } from "ng2-dragula";
import { BoardService } from "src/shared/services/board.service";
import { UserService } from "src/shared/services/user/user.service";
import { DialogPermissionsNodeComponent } from "../../+my-libraries/+workspaces/dialog-permissions-node/dialog-permissions-node.component";
import { DialogConfirmComponent } from "../../shared/components/dialog-confirm/dialog-confirm.component";
import { DialogEditTitleComponent } from "../components/dialog/dialog-editTitle/dialog-editTitle.component";
import { DialogPermissionsKanbanComponent } from "../components/dialog/dialog-permissions-kanban/dialog-permissions-kanban.component";
import { DialogComponent } from "../components/dialog/dialog/dialog.component";
import { EventEmitter } from "@angular/core";
import { element } from "protractor";
import { last } from "rxjs/operators";


@Component({
  selector: 'see-kanban',
  templateUrl: './see-kanban.component.html',
  styleUrls: ['./see-kanban.component.scss']
})
export class SeeKanbanComponent implements OnInit {



  public item;
  public columns = [];
  public firstkanban
  public taskList = [];
  arrow: any;
  public activeLinkIndex: number = 0;
  public kanbans = [];
  user: string;

  @Output() changeKanban: EventEmitter<any> = new EventEmitter;

  constructor(
    private router: Router,
    public boardService: BoardService,
    private dragulaService: DragulaService,
    public activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private userService: UserService,



  ) { }

  async ngOnInit(): Promise<void> {
    this.initComponent();
  }

  initComponent() {
    this.boardService.getKanbans().subscribe((res) => {

      this.kanbans = res;
      this.setPermissionsNodes(this.kanbans)
      this.activatedRoute.params.subscribe(async params => {
        this.activeLinkIndex = this.kanbans.findIndex(x => x._id === params.id);
        if (params.id == null) {


          this.kanbans.forEach(element => {
            if (element.isPermit == true) {
              return this.router.navigate([
                "/home/kanban/", element._id
              ])
            }
          });

        }
      })
    })

    this.user = this.userService.user.completeName
    this.arrow = 'file-manager-false';
  }


  ngOnChanges() {
    this.initComponent
  }


  public selectLink(index: number, route: string) {
    this.activeLinkIndex = index;
    this.router.navigate([
      "/home/kanban/", route
    ]);
    this.changeKanban.emit(route);
  }

  private setPermissionsNodes(nodes) {
    // nodes.forEach(element => {
    //   element.isPermit = false;
    //   if (element.privacy == "specific") {
    //     element.listPeopleAuthorized.forEach(el => {
    //       if (el.uType == "cm:person") {
    //         if (el.id == this.userService.user.id) {
    //           element.isPermit = true;
    //         }
    //       } else if (el.uType == "cm:authorityContainer") {
    //         this.userService.user.groups.forEach(group => {

    //           if (group.id == el.id) {
    //             element.isPermit = true;
    //           }
    //         });
    //       }
    //     });
    //   } else if (element.privacy == "only-me") {
    //     if (element.creator == this.userService.user.completeName) {
    //       element.isPermit = true;
    //     }
    //   } else if (element.privacy == "public") {
    //     element.isPermit = true;
    //   } else {
    //     element.isPermit = true;
    //   }

    //   if (element.columnList && element.columnList.length) {
    //     this.setPermissionsNodes(element.columnList);
    //   }
    // });


    nodes.forEach(element => {
      switch (element.privacy) {
        case 'specific':
          element.listPeopleAuthorized.forEach(el => {
            if (el.uType == "cm:person") {
              if (el.id == this.userService.user.id) {
                element.isPermit = true;
              }
            } else if (el.uType == "cm:authorityContainer") {
              this.userService.user.groups.forEach(group => {

                if (group.id == el.id) {
                  element.isPermit = true;
                }
              });
            }
          });

          break;
        case 'only-me':
          if (element.creator == this.userService.user.completeName) {
            element.isPermit = true;
          }

          break;
        default:
          element.isPermit = true;
          break
      }
      if (element.columnList && element.columnList.length) {
        this.setPermissionsNodes(element.columnList);
      }
    })
  }

  public addKanban(title) {
    let addkanban = true;
    let afaire = true;
    let encours = true;
    let finis = true;

    if (title) {
      this.boardService.addKanban(title)
        .toPromise()
        .then(res => {
          this.boardService.addColumn("A Faire", res._id, addkanban, afaire, encours, finis, finis)
            .toPromise()
            .then(result => {
              afaire = false, this.boardService.addColumn("En cours", res._id, addkanban, afaire, encours, finis, finis)
                .toPromise()
                .then(result => {
                  encours = false, this.boardService.addColumn("Finis", res._id, addkanban, afaire, encours, finis, finis)
                    .toPromise()
                    .then(res => { finis = false })
                })
            }
            )
          this.initComponent();
        })
    }
  }

  public deleteKanban(kanbanId) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: "auto",
      height: "auto",
      data: {
        text: `Souhaitez-vous réellement supprimer le kanban ?`
      }
    })
    ;

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.boardService.deleteKanban(kanbanId._id)
          .toPromise()
          .then(res => {
          this.initComponent()
        });
      }
    })
    ;


  }

  onAddComment(comment, columnId: string, taskId: string) {
    this.boardService.addComment(comment, columnId, taskId)
      .toPromise()
      .then(res => this.initComponent())
  }

  onDeleteComment($event, columnId, taskId, commentId) {
    this.boardService.deleteComment(columnId, taskId, commentId)
      .toPromise()
      .then(res => this.initComponent())
  }

  permissions(node: any) {
    const dialogRef = this.dialog.open(DialogPermissionsKanbanComponent, {
      width: "60%",
      height: "auto",
      data: {
        actualNode: node
      }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        node.privacy = res.privacy;
        node.listPeopleAuthorized = res.listPeopleAuthorized;

        //appel du back !
      }
    });
  }

  public editTitle($event, kanbanId, kanban) {
    const dialogRef = this.dialog.open(DialogEditTitleComponent, {
      width: "auto",
      height: "auto",
      data: {
        question: "Modifier le kanban",
        text: kanban.title
      }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.boardService.EditTitleKanban(res, kanbanId, kanban)
          .toPromise()
          .then(res => {
            this.initComponent()
          });
      }
    });
  }

}